// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { columnsStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListColumns";
import { plpAccordion } from "@steiner/XDL/PreStyle/accordion";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

columnsStyles.container = {
    css: css`
        display: grid;
        grid-gap: 42px;
        grid-template-columns: 297px minmax(0, 1fr);
        grid-template-rows: 1fr;
        ${xScreen("lte", "md")} {
            grid-template-columns: 100%;
            grid-template-rows: auto;
            grid-gap: 16px;
        }
    `,
};
columnsStyles.leftColumnItem = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
        @media print {
            display: none;
        }
    `,
};

columnsStyles.rightColumnItem = {
    css: css`
        flex-direction: column;
        @media print {
            display: block;
            width: 100%;
        }
    `,
};
columnsStyles.filtersAccordionItem = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: flex;
            width: 100%;
            flex-direction: column;
            padding-bottom: 0;
        }
    `,
};
columnsStyles.plpAccordion = {
    ...mergeWithCss(plpAccordion, {
        headerProps: {
            css: css`
                width: 100%;
            `,
        },
        panelProps: {
            css: css`
                width: 100%;
            `,
        },
        titleTypographyProps: {
            variant: "h3",
            color: "common.white",
            css: css`
                margin: 0;
            `,
        },
    }),
};
